<template>
    <v-snackbar
        v-model="showSnackbar"
        color="primary"
        location="center"
        multi-line
        :timeout="-1"
        content-class="text-center"
    >
        <div class="d-flex justify-space-between font-weight-thin opacity-80">
            <div class="text-overline mb-2">{{ $t('incoming_call') }}</div>
            <v-btn icon="mdi-close" size="x-small" variant="text" @click="showSnackbar = false" />
        </div>
        <div class="d-flex justify-space-between align-center">
            <div>
                <div v-if="profileName && profileRoute" class="text-body-1 mb-1 font-weight-medium">
                    <v-icon v-if="profileIcon" start>{{ profileIcon }}</v-icon> {{ profileName }}
                </div>
                <div class="opacity-80">{{ personName ? `${personName} | ` : '' }}{{ props.phone }}</div>
            </div>
            <nuxt-link
                v-if="profileName && profileRoute"
                :to="profileRoute"
                class="text-white text-decoration-none me-2"
                @click="showSnackbar = false"
            >
                {{ $t('see_profile') }}
            </nuxt-link>
        </div>
    </v-snackbar>
</template>

<script setup lang="ts">
    const props = defineProps<{
        phone: string
    }>()

    const {$api} = useNuxtApp()

    const showSnackbar = ref(true)

    const profileName = ref()
    const profileIcon = ref()
    const profileRoute = ref()
    const personName = ref()

    onMounted(async () => {
        try {
            const [resultCompanies, resultPersons, privateClients] = await Promise.allSettled([
                $api.companies.get({phone: props.phone, limit: 1}),
                $api.persons.get({phone: props.phone, limit: 1}),
                $api.privateClients.get({phone: props.phone, limit: 1}),
            ])
            if (resultPersons.status === 'fulfilled') {
                const user = resultPersons.value.users?.[0]
                if (user) {
                    profileIcon.value = 'mdi-domain'
                    personName.value = `${user.firstName || ''} ${user.lastName || ''}`
                    profileName.value = user.companyName
                    if (authStore.person.companyId === user.companyId) {
                        profileRoute.value = {name: 'company-profile'}
                    } else {
                        profileRoute.value = {name: 'company-client-profile', params: {id: user.companyId}}
                    }
                    return
                }
            }
            if (resultCompanies.status === 'fulfilled') {
                const company = resultCompanies.value.companies?.[0]
                if (company) {
                    profileIcon.value = 'mdi-domain'
                    profileName.value = company.name
                    const name = ['HUB_SUPPLIER', 'INTERNAL_SUPPLIER'].includes(company.type)
                        ? 'companySupplier'
                        : 'company-client-profile'
                    profileRoute.value = {name, params: {id: company.id}}
                    return
                }
            }
            if (privateClients.status === 'fulfilled') {
                const person = privateClients.value.persons?.[0]
                if (person) {
                    profileIcon.value = 'mdi-account'
                    profileName.value = `${person.firstName || ''} ${person.lastName || ''}`
                    profileRoute.value = {name: 'companyClient', params: {id: person.personId}}
                }
            }
        } catch {
            profileIcon.value = null
            profileName.value = null
            profileRoute.value = null
        }
    })
</script>
